module.exports = __webpack_public_path__ + "media/images/pages/ai/icon-inclusive-c90f6b12aadfd0d34ef3b8f4157666b1.svg";